import ReceiptIcon from '@mui/icons-material/Receipt';
import classes from "./integrationStyles.module.scss"
import { Col, Collapse, Row } from 'react-bootstrap';
import Button from '../UI/Button';
import AddIcon from '@mui/icons-material/Add';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { useContext, useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { DDD, E2Data } from '../../lib/ddd/ddd';
import { useQuery } from '@tanstack/react-query';
import { Alert, Divider, IconButton, InputBase, Paper, Skeleton } from '@mui/material';
import NumbersIcon from '@mui/icons-material/Numbers';
import PersonIcon from '@mui/icons-material/Person';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import SearchIcon from '@mui/icons-material/Search';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { OrgIdContext } from '../../store/orgId_context';
import { useTranslation } from 'react-i18next';


const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const rowCount = 5;
/*const e2data = new E2Data("EU_Invoices");
e2data.skip = 0;
e2data.take = rowCount;
e2data.includeCount=true;
e2data.orderBy="DateTimeCreate desc";*/


const ActiveInvoicePicker = ({invoiceId, onCreateNew, onInvoiceSelected, onExecuteResponse, isIntegration=true, orangeText, blueText, ...props})=>{
    const { integrationDevice, connectionKey} = useContext(OrgIdContext);
    const [collapsed, setCollapsed] = useState(false);
    const [page, setPage] = useState(0);
    const [data, setData] = useState([]);
    const [pagesCount, setPagesCount] = useState(0)
    const [isPending, setIsPending] = useState(true);
    const [searchInput, setSearchInput] = useState("");
    const [e2data, setE2Data] = useState(E2Data.WithConnectionKey(apiRequestAddress, isIntegration?integrationDevice:connectionKey,"EU_Invoices"));
    const {t} = useTranslation();
    
    useEffect(() => {
        e2data.skip = 0;
        e2data.take = rowCount;
        e2data.includeCount=true;
        e2data.orderBy="DateTimeCreate desc";
        appendFilter(e2data);
        reload();
    }, [integrationDevice]);

    const appendFilter = (_e2data) =>{
        if(!e2data) return;

        let append = isIntegration ? "DeviceId__AssignedTo = 'CKI'" : "DeviceId__AssignedTo <> 'CKI'";
        if(_e2data.filter)
            _e2data.filter += ` AND ${append}`;
        else
            _e2data.filter = append;
    }

    const handlePageClick = (e) =>{
        setIsPending(true);
        setPage(e.selected);
        e2data.skip = 5*e.selected;
        e2data.GetData().then(res => {
            setIsPending(false);
            if(!res || !res.result)
                return console.error("Error getting data");

            setPagesCount(parseInt(res.result.count/rowCount)+1)
            setData(res.result.data);
        });
    }


    useEffect(() => {
        reload();
    }, [onExecuteResponse]);

    useEffect(() =>{
        //reload();
    },[]);

    const reload = () =>{
        setIsPending(true);
        e2data.GetData().then(res => {
            if(!res || !res.result)
                return;

            setData(res.result.data);
            setPagesCount(parseInt(res.result.count/rowCount)+1)
            setIsPending(false);
        });
    }

    const onSearch = () =>{
        if(searchInput === null || searchInput===""){
            e2data.filter=null;
            appendFilter(e2data);
        }else{
            let filter = "";
            

            filter += `BuyerFormalName contains "${searchInput}"`
            filter += ` OR BuyerTaxNum contains "${searchInput}"`
            filter += ` OR BuyerOrderRef contains "${searchInput}"`

            const guidReg = /^([0-9A-Fa-f]{8}[-]?[0-9A-Fa-f]{4}[-]?[0-9A-Fa-f]{4}[-]?[0-9A-Fa-f]{4}[-]?[0-9A-Fa-f]{12})$/gim
            if(searchInput.match(guidReg)){
                filter = `Id = "${searchInput}"`
            }

            e2data.filter = filter;
            appendFilter(e2data);
        }
        setPage(0);
        e2data.skip =0;
        reload();
    }

    const onSubmit = (e)=> {
        e.preventDefault()
        onSearch();
    }

    const removeFilter = () =>{
        setSearchInput("");
        setPage(0);
        e2data.skip =0;
        e2data.filter = null;
        appendFilter(e2data);
        reload();
    }

    const onRowSelected = (row) => {
        if(onInvoiceSelected)
            onInvoiceSelected(row);
        setCollapsed(false);
    }

    return(<>
    <div className={`${classes["container"]}`} style={{height:"auto"}}>
        <div className="flex d-flex">
            {invoiceId && <>
                <div><ReceiptIcon/></div>
                <span>{blueText ? blueText : t("Currently editing invoice")}: </span>
                <span id="activeInvoice" className={classes["invoice-id"]}>{invoiceId}</span>
            </>}
            {!invoiceId && <span style={{color:"#df511d"}}><ReportProblemIcon style={{marginRight:"1rem"}}/>{orangeText ? orangeText : <>{t("First select an invoice by pressing the")} {"<<"} {t("button or create a new invoice")}</>}</span>}
            <div style={{marginLeft: "auto", paddingRight:"0.5rem", whiteSpace:"nowrap"}}>
                {props.HideCreate !== true && <Button id="activeInvoiceBtn" onClick={onCreateNew} style={{marginRight:"1rem"}}><AddIcon/>{t("Create")}</Button>}
                <Button id="activeInvoiceBtn" onClick={() => setCollapsed(prev=>!prev)}>{collapsed ? <KeyboardDoubleArrowDownIcon/> : <KeyboardDoubleArrowLeftIcon/>}</Button>
            </div>
        </div>
        <Collapse in={collapsed}>
            <div style={{margin:"0px", padding:"0px"}}>
                <div className="flex d-flex">
                    <span style={{marginTop:"1rem", fontSize:"large", color:"black"}}>{t("Select another")}:</span>
                    <div style={{marginLeft: "auto"}}>
                    <Paper component="form" onSubmit={onSubmit} sx={{ m: "1rem 0rem 0rem 0rem",p: '2px 4px', display: 'flex', alignItems: 'center', width: 300 }}>
                        {searchInput!==null && searchInput!=="" && 
                            <IconButton type="button" sx={{ p: '5px' }} aria-label="remove" onClick={removeFilter}>
                                <DoDisturbIcon />
                            </IconButton>
                        }
                        <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search"
                        inputProps={{ 'aria-label': 'search' }}
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        />
                        <IconButton type="button" sx={{ p: '5px' }} aria-label="search" onClick={onSearch}>
                            <SearchIcon />
                        </IconButton>
                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                    </Paper></div>
                </div>
                <Divider  orientation="horizontal" />
                <table className="table align-middle mb-0" style={{marginTop:"1rem"}}>
                <thead >
                    <tr className={classes["picker-title-tr"]}>
                        <th><NumbersIcon/>{t("Step")}</th>
                        <th><PersonIcon/>{t("Buyer")}</th>
                        <th><AttachMoneyIcon/>{t("Amount")}</th>
                        <th><CalendarMonthIcon/>{t("Created")}</th>
                        <th><FingerprintIcon/>{t("Order ref")}</th>
                    </tr>
                </thead>
                <tbody>
                {isPending && [...Array(rowCount)].map(() => {
                    return (<tr>
                        <td><Skeleton><td><div className={classes["step-circle"]}>1</div></td></Skeleton></td>
                        <td><Skeleton></Skeleton></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>)
                })}
                {!isPending && data.map(row => {
                        return(<>
                        <tr className={classes["picker-tr"]} onClick={() => onRowSelected(row)} style={invoiceId === row.Id ? {backgroundColor:"#a8d3ff"} : {}}>
                            <td width="50px"><div className={classes["step-circle"]} style={row.StepStatus === "Error" ?  {color:"#f94b4b"} : {color:"white"}}>{row.Step}</div></td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div className="ms-3">
                                        <p className="fw-bold mb-1">{row.BuyerFormalName}</p>
                                        <p className="text-muted mb-0">{row.BuyerTaxNum}</p>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <p className="fw-normal mb-1">{row.InvAmountExclVat}</p>
                                <p className="text-muted mb-0">{row.InvAmountInclVat}</p>
                            </td>
                            <td>
                                <span className="">{(new Date(row.DateTimeCreate)).toLocaleString()}</span>
                            </td>
                            <td>
                                <span className="">{row.BuyerOrderRef}</span>
                            </td>
                        </tr>
                        </>)
                    })
                }
                </tbody>
                </table>
                <ReactPaginate
                    breakLabel="..."
                    nextLabel={<KeyboardDoubleArrowRightIcon style={{color:"#005683"}}/>}
                    previousLabel={<KeyboardDoubleArrowLeftIcon style={{color:"#005683"}}/>}
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={3}
                    pageCount={pagesCount}
                    
                    renderOnZeroPageCount={null}
                    containerClassName={classes["pagination-main"]}
                    pageClassName={classes["pagination-item"]}
                    pageLinkClassName={classes["pagination-link"]}
                    activeClassName={classes["pagination-item-active"]}
                    forcePage = {page}
                />
            </div>
        </Collapse>
    </div>
    
    </>)
}
export default ActiveInvoicePicker;